// For pickers and machine-read values; shown dates use formatDateTime (utils/time.js).
export const sortableDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const longDateTimeFormat = 'HH:mm:ss, DD MMM YYYY';
export const longDateFormat = 'DD-MM-YYYY'
export const timeFormat = 'HH:mm';
export const timeFormatSeconds = 'HH:mm:ss';
export const dateTimeColumnWidth = 180;
